module.exports = __webpack_public_path__ + "assets/57f17a274ae36c5520a7c4a0d3133ac0.png";